import {observer} from "mobx-react-lite";
import {ActionComparison} from "./ActionComparison";
import React from "react";
import {syncOrdersController as controller} from "../../store/pageControllers/syncOrdersController";
enum eventsSender {
    ozonEvents = 'ozonEvents', shopEvents = 'shopEvents'
}

export const StateActionsTables = observer(({model}:{model?: string}) => {
    if (!model) {
        model = 'FBS'
    }
    let smodel = model

    const group = controller.getGroupOfActionByModel(model)

    return <>
        {[
            {
                header1: 'Сменить статус в Ozon',
                header2: 'При действии в Shop-script',
                header3: 'Сменить статус в Ozon при действии в Shop-Script',
                name: eventsSender.shopEvents,
                isMulti: true
            },
            {
                header1: 'При смене статуса в Ozon',
                header2: 'Выполнить действие в Shop-Script',
                header3: 'При смене статуса в Ozon автоматически выполнить действие в Shop-Script',
                name: eventsSender.ozonEvents,
                isMulti: false
            }
        ].map((eventSender, index) => <div key={index}>
            <h5 style={{marginTop: '20px'}}>{eventSender.header3}</h5>
            <table>
                <thead style={{backgroundColor: "#F3F3F3"}}>
                <tr>
                    <th>{eventSender.header1}</th>
                    <th/>
                    <th>{eventSender.header2}</th>
                </tr>
                </thead>
            </table>
            {group[eventSender.name].map((pair, index) => <ActionComparison
                key={index + smodel + eventSender.name}
                pair={pair}
                model={group.name}
                eventSender={eventSender.name}
                isMulti={eventSender.isMulti}
            />)}
        </div>)
        }
    </>
})